'use client';
import { createContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const SwanListboxButtonContext = createContext(void 0);
function useSwanListboxButtonContext() {
    return useNonNullishContext(SwanListboxButtonContext);
}

export { SwanListboxButtonContext, useSwanListboxButtonContext };
